<template>
    <div>
        <swb-query-sort-area name="query_model_ctrl" ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出</a>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :rowNoShow="rowNoShow"
                          :rowNoFixed="rowNoFixed"
                          :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="handlePageChange"
                          :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf';
import { checkUserActionPerm } from '../index'
import { showGrpDownloadDlg } from '../ctrl/dialog'
import {showRouteLayer} from '../ctrl/RouteLayer';
//
import userApi from '../../api/user'
import goodsDelivApi from '../../api/goodsDeliv'
import servcDelivApi from '../../api/servcDeliv'
import servcDisptApi from '../../api/servcDispt'

import SwbGoodsRecvVoucherInfo from './GoodsRecvVoucherInfo';

Vue.regist(SwbGoodsRecvVoucherInfo);

import SwbGoodsExchgVoucherSave from './GoodsExchgVoucherSave';

Routes.add(SwbGoodsExchgVoucherSave);

import SwbGoodsReturnVoucherSave from './GoodsReturnVoucherSave';

Routes.add(SwbGoodsReturnVoucherSave);

import SwbGoodsShipVoucherList from './GoodsShipVoucherList';

Routes.add(SwbGoodsShipVoucherList);

import SwbLogisTraceInfo from './LogisTraceInfo';

Vue.regist(SwbLogisTraceInfo);

import SwbQuerySortArea from '../query/QuerySortArea';

Vue.regist(SwbQuerySortArea);

import SwbServcWorkVoucherSetupSave from '../workVoucher/ServcWorkVoucherSetupSave';

Vue.regist(SwbServcWorkVoucherSetupSave);

import SwbGoodsOrderList from './GoodsOrderList';

Routes.add(SwbGoodsOrderList);

import SwbShopDeviceList from '../devc/ShopDeviceList'

Routes.add(SwbShopDeviceList);

import SwbContractGoodsOrderList from './ContractGoodsOrderList';
Routes.add(SwbContractGoodsOrderList);

let searchConfigData = {
    'queryFields': [{
        'type': 'Text',
        'label': '收货单号',
        'code': 'no',
        'valueType': 'String',
        'basic': true
    }, {
        'type': 'Text',
        'label': '标题',
        'code': 'title',
        'valueType': 'String',
        'basic': true
    }, {
        'type': 'Text',
        'label': '订单号',
        'code': 'orderNo',
        'valueType': 'String',
        'basic': true
    }, {
        'type': 'Date2',
        'label': '收货日期',
        'code': 'receiveDate',
        'basic': true,
        'valueType': 'String'
    }, {
        'type': 'Text',
        'label': '收货机构',
        'code': 'buyerShopName'
    }, {
        'type': 'Text',
        'label': '发货商家',
        'code': 'sellerComName',
        'basic': false
    },
        {
            'code': 'returnFlag',
            'label': '退货状态',
            'type': 'Select',
            'valueType': 'Integer',
            'value': null,
            'basic': false,
            'hidden': false,
            'rptUsed': false,
            'ctxBindName': null,
            'dataList': [
                {
                    'label': '-全部-',
                    'value': null
                },
                {
                    'label': '未退货',
                    'value': '0'
                },
                {
                    'label': '部分退货',
                    'value': '1'
                },
                {
                    'label': '全部退货',
                    'value': '2'
                }
            ]
        }],
    'sortFields': [{
        'label': '创建时间',
        'code': 'createTime',
        'order': 'desc',
        'enabled': true
    }, {
        'order': 'desc',
        'label': '收货日期',
        'code': 'actualArriveDate',
        'enabled': true
    }]
};

export default {
    name: 'swb-goods-recv-voucher-list',
    path: '/goods/recv/voucher/list',
    avlActions: 'view_detail|exchg|return|view_logis',
    avlActionNames: '详情、换货、退货',
    avlScopes: 'retailer',
    desc: '收货单列表',
    authen: false,
    props: ['goodsOrderId'],
    data: function () {
        return {
            confKey: 'swb-goods-recv-voucher-list',
            theTableHeight: 700,
            queryOnLoad: true,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: true, //行号列是否固定（默认：false）
            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 260,//操作列宽度（默认：100）
            btnColFixed: true, //操作列是否固定
            //
            pageNumber: 1,
            totalCount: 1,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //排序、搜索
            queryConfig: null,
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            exportFilter: {},
            //
            goodsRecvVoucherList: [],
            no: null,
            isShop: false,
            searchShow: false,
            //
            exceptional: false,
            buyerShopName: null,
            sellerComName: null,
            receiveDateStart: null,
            receiveDateEnd: null
        }
    },
    created: function () {
        this.pageSize = this.pageSizes.first();
        //----------------------搜索排序----------------------------
        this.queryConfig = searchConfigData || {};
        // --------------------查询--------------------------------
        this.getGoodsRecvVouchers();
        this.getCurrentUserInfo();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;

        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.simple-row, [name="query_model_ctrl"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.tradeNo != null) {
                        return '<span><a class="table-cell-link" >' + row.tradeNo + '</a></span>';
                    }
                },
                'returnFlagX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.returnFlag == 1) {
                        return '<span class="font-red">部分退货</span>';
                    } else if(row.returnFlag == 2) {
                        return '<span class="font-red">全部退货</span>';
                    }
                },
                'actions': function (row, colName, colValue, rowIndex, colConf) {
                    let btnList = [];
                    if(self.checkActionPerm('view_detail')) {
                        btnList.push({
                            name: 'view_detail',
                            text: '详情'
                        })
                    }
                    // goodsRecvVoucher.existPurchReceiptFlag 不存在有效验收单
                    if(self.checkActionPerm('exchg') && row.exchgOrReturnable && !row.existPurchReceiptFlag) {
                        btnList.push({
                            name: 'exchg',
                            text: '换货'
                        })
                    }
                    // goodsRecvVoucher.existPurchReceiptFlag 不存在有效验收单
                    if(self.checkActionPerm('return') && row.exchgOrReturnable && !row.existPurchReceiptFlag) {
                        btnList.push({
                            name: 'return',
                            text: '退货'
                        })
                    }
                    if(self.checkActionPerm('view_logis') && row.returnLogisExpNo != null && row.returnLogisComCode != null) {
                        btnList.push({
                            name: 'view_logis',
                            text: '物流查询'
                        })
                    }
                    if(self.checkActionPerm('setup') && row.unSetupQuantity != 0 && row.totalCount - row.exchgSumQuantity - row.returnSumQuantity > 0) {
                        btnList.push({
                            name: 'setup',
                            text: '发起安装'
                        })
                    }
                    if(self.checkActionPerm('to_asmbl') && row.unAsmblQuantity != 0 && row.totalCount - row.exchgSumQuantity - row.returnSumQuantity > 0) {
                        btnList.push({
                            name: 'to_asmbl',
                            text: '组装'
                        })
                    }

                    return btnList
                },
            }, /* 单元格按钮点击处理函数 */ {
                'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                    self.toTradeVoucherList(row.tradeNo, row.contractNo)
                },
                'cgVoucherInnerNo': function (row, colName, colValue, rowIndex, btnName) {
                    if(row.cgVoucherId != -1) {
                        self.toCgVoucherList(row.cgVoucherNo, row.cgStuffFlag)
                    }
                },
                'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                    if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                        return;
                    }
                    if(btnName == 'view_detail') { // 详情
                        self.goGoodsRecvVoucherInfo(row.id);
                    } else if(btnName == 'exchg') { // 换货
                        self.goGoodsExchgVoucherInfo(row.id);
                    } else if(btnName == 'return') { // 退货
                        self.goGoodsReturnVoucherInfo(row.id);
                    } else if(btnName == 'view_logis') { // 物流查询
                        self.logisFound(row.returnLogisExpNo, row.returnLogisComCode);
                    } else if(btnName == 'setup') { // 发起安装
                        self.toSetup(row.id);
                    } else if(btnName == 'to_asmbl') { // 组装
                        self.toAsmbl(row);
                    }
                }
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        queryHandler(queryModel) {
            //1、接收查询条件
            this.queryModel = queryModel;
            //缓存查询条件
            this.pageNumber = 1;
            //
            this.getGoodsRecvVouchers();
        },
        // 检查资源具体操作权限（可选的是否为指定的岗位id）
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
        },
        showSearch: function (flag) {
            this.searchShow = flag;
        },
        toGoodsOrderList: function (orderNo, contractId) {
            if(Utils.isNoB(orderNo)) {
                return;
            }
            let data = {no: orderNo};
            let path = SwbGoodsOrderList.path;
            if(contractId != null) {
                path = SwbContractGoodsOrderList.path;
            }
            let hashUrl = Utils.makeUrl(path, data);
            appConf.openPageRouteUrl(null, '/bench/home', hashUrl)
        },
        toGoodsShipVoucherList: function (no) {
            let pushDate = {};
            pushDate.path = SwbGoodsShipVoucherList.path;
            let queryData = {no: no};
            if(no != null) {
                pushDate.query = queryData;
            }
            this.$router.push(pushDate);
        },
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber, val);
        },
        handlePageChange: function (pageNumber, pageSize) {
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getGoodsRecvVouchers();
        },
        getCurrentUserInfo: function () {
            let self = this;
            let postData = {};
            userApi.getUserInfoByContext(postData, function (result) {
                if(result.type == 'info') {
                    let data = result.data;
                    if(data.scopeEntity != null) {
                        if(data.scopeEntity.shopFlag) {
                            self.isShop = true;
                        }
                    }
                }
            });
        },
        getGoodsRecvVouchers: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber
            };

            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            if(self.goodsOrderId != null) {
                filterItems.orderId = self.goodsOrderId;
            }
            filterItems.ioFlag = 1;
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            self.exportFilter = Utils.merge({}, filterItems);
            //
            let msgBoxDlg = MsgBox.loading();
            goodsDelivApi.getGoodsRecvVoucherList(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let goodsRecvVoucherList = result.data.rows;
                    goodsRecvVoucherList.forEach(function (voucher) {
                        // setupFlag
                        // asmblFlag
                        let setupFlagQuantity = 0;
                        let asmblFlagQuantity = 0;
                        voucher.goodsRecvVoucherItemList.forEach(function (item) {
                            if(item.setupFlag) {
                                setupFlagQuantity += item.quantity;
                            }
                            if(item.asmblFlag) {
                                asmblFlagQuantity += item.quantity;
                            }
                        });
                        voucher.setupFlagQuantity = setupFlagQuantity;
                        voucher.asmblFlagQuantity = asmblFlagQuantity;
                    });
                    //

                    self.goodsRecvVoucherList = goodsRecvVoucherList;
                    //
                    let pagination = result.data.pagination;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.pageSize = pagination.pageSize;
                    self.renderTable(goodsRecvVoucherList, pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        goGoodsRecvVoucherInfo: function (id) {
            showRouteLayer({
                title: '收货单详情',
                query: {id: id},
                template: SwbGoodsRecvVoucherInfo
            });
        },
        goGoodsExchgVoucherInfo: function (id) {
            let self = this;
            let pushData = {};
            pushData.path = SwbGoodsExchgVoucherSave.path;
            pushData.query = {id: id};
            self.$router.push(pushData);
        },
        goGoodsReturnVoucherInfo: function (id) {
            let self = this;
            let pushData = {};
            pushData.path = SwbGoodsReturnVoucherSave.path;
            pushData.query = {id: id};
            self.$router.push(pushData);
        },
        logisFound: function (logisExpNo, logisComCode) {
            //
            if(logisExpNo != null && logisComCode != null) {
                //
                Vue.$showDialog({
                    title: '物流信息',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    template: '<div>' +
                        '<swb-logis-trace-info :logisExpNo="logisExpNo" :logisComCode="logisComCode" ref="swb_logis_trace_info"></swb-logis-trace-info>' +
                        '</div>',
                    data: {
                        logisExpNo: logisExpNo,
                        logisComCode: logisComCode
                    },
                    methods: {},
                    okClicked: function () {
                    },
                })
            } else {
                MsgBox.warning('物流参数信息异常');
            }
        },
        toSetup(id) {
            let self = this;
            let theDlg = Vue.$showDialog({
                title: '安装工单-新增',
                width: 1100,
                height: 750,
                template: '<div class = "">' +
                    '<swb-servc-work-voucher-setup-save :recvId = "recvId" ref="swb_servc_work_voucher_setup_save"></swb-servc-work-voucher-setup-save>' +
                    '</div>',
                data: {
                    recvId: id
                },
                okClicked: function () {
                    let voucher = this.$refs.swb_servc_work_voucher_setup_save.getDlgResult();
                    console.log(voucher);
                    if(voucher != null) {
                        if(Utils.isNoB(voucher.srcMerchantId)) {
                            let msgBoxDlg = MsgBox.loading();
                            servcDelivApi.saveServcWorkVoucherForSetup(voucher, function (result) {
                                msgBoxDlg.close();
                                if(result.type == 'info') {
                                    theDlg.close();
                                    MsgBox.success('操作成功');
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            let msgBoxDlg = MsgBox.loading();
                            servcDisptApi.saveServcReqVoucherForSetup(voucher, function (result) {
                                msgBoxDlg.close();
                                if(result.type == 'info') {
                                    theDlg.close();
                                    MsgBox.success('操作成功');
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                    return false;
                }
            });
        },
        toAsmbl(row) {
            let filter = {
                includeSubComs: true,
                recvVoucherId: row.id,
                asmblFlag: true,
                asmblDone: false,
                asmblWhileSetup: false,
                queryIncludeNotWarehouse: true
            };
            this.$router.push({
                path: SwbShopDeviceList.path,
                query: {
                    filter: filter
                }
            })
        },
        // 导出
        doExport: function () {
            let self = this;
            let pageSize = getDefaultDownloadPageSize();
            let pages = Math.ceil(self.totalCount / pageSize);
            if(pages > 10) {
                showPageRangeSelDlg('选择导出文件序号', pages, 10, this.lastPageNumber, function (ok, range) {
                    if(ok) {
                        if(range.to == pages) {
                            self.lastPageNumber = 0;
                        } else {
                            self.lastPageNumber = range.to;
                        }
                        //
                        self.exportPrintData(pageSize, range.from, range.to);
                    }
                }, {pageSize: pageSize})
            } else {
                self.exportPrintData(pageSize);
            }
        },
        exportPrintData(pageSize, fromPages, toPages) {
            let totalCount = this.totalCount;
            let pages = Math.ceil(totalCount / pageSize);
            //
            fromPages = fromPages == null ? 1 : fromPages;
            toPages = toPages == null ? pages : toPages;
            let tableData = this.getTableData(pages, pageSize);
            //
            let url = getAppUrl('/file/export/as/excel');
            let downloadUrls = [];
            for(let i = fromPages; i <= toPages; i++) {
                let tmpFile = {};
                tmpFile.url = url;
                tmpFile.post = true;
                tmpFile.fileName = '收货单管理' + (pages == 1 ? '' : ('_' + (i)));
                tmpFile.seqNo = i;
                //
                let data = Utils.merge({}, tableData);
                data.pageNumber = i;
                data.fileName = tmpFile.fileName;
                tmpFile.data = data;
                downloadUrls.push(tmpFile);
            }
            let title = '收货单管理-下载| 每个文件' + pageSize + '条数据';
            showGrpDownloadDlg(title, downloadUrls);
        },
        getTableData(pages, pageSize) {
            let resultTable = this.$refs.result_table;
            let tableData = resultTable.getTableData(true);
            delete tableData.rows;//减少数据传输量
            //
            let rowsSrc = {};
            rowsSrc.data = this.getPostData();
            rowsSrc.url = '/goodsDeliv/recv/voucher/list/get';
            tableData.rowsSrc = rowsSrc;
            //
            tableData.pageSize = pageSize;
            tableData.pageCount = this.totalCount;
            tableData.pages = pages;
            return tableData;
        },
        getPostData() {
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, this.exportFilter);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            let multipleSelection = this.getTableSelection();
            if(multipleSelection.length > 0) {
                let ids = [];
                multipleSelection.forEach(function (el) {
                    ids.push(el.id);
                });
                filterItems.ids = ids;
            }
            filterItems.exportFlag = true;
            //
            let postData = {};
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            return postData;
        },
    }
}
</script>






// WEBPACK FOOTER //
// src/compo/order/GoodsRecvVoucherList.vue